
import { Component, Vue } from "vue-property-decorator";
import { catalogService } from "@/services/api/catalogs.service";
import { getModule } from "vuex-module-decorators";
import AuthModule from "@/store/modules/core/auth.module";
import store from "@/store";
const authModule = getModule(AuthModule, store);
const AppBar = () => import("@/components/core/AppBar.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");
const MessageDialog = () => import("@/components/core/MessageDialog.vue");

@Component({
  components: {
    AppBar,
    AppFooter,
    MessageDialog,
  },
})
export default class CatalogsReload extends Vue {
  // VARS
  private isLoading = false;
  private search = "";
  private selectedCatalog = null;
  private catalogs = [
    { text: "MAK", value: 2 },
    { text: "FERRO", value: 1 },
    // { text: 'GMP', value: 5 }, // BN: Removed for not sold anymore.
  ];
  private headers = [
    {
      text: "Diametro",
      align: "start",
      filterable: true,
      value: "diameter",
    },
    { text: "Ricarico privato €", value: "privateQtyToAdd" },
    { text: "Ricarico pubblico €", value: "publicQtyToAdd" },
    {
      text: "Salva",
      value: "Actions",
      align: "center",
      class: "table_header__actions",
    },
  ];
  private set = [];
  private entriesModified = [];
  private isLoadingButton = false;

  // VARS --- COMPONENTS
  private numberSelected = 0;
  private messageDialogOpen = false;
  private dialogText = "";

  private beforeCreate(): void {
    if (authModule.role != "0") {
      this.$router.push("/");
    }
  }

  // METHODS --- POPULATE TABLE BASED ON CHOICE
  private refreshTable(choice): void {
    this.selectedCatalog = choice.value;
    this.isLoading = true;
    // API here
    catalogService.getCatalogs(choice.value).then((res) => {
      this.set = res.data;
      this.isLoading = false;

      this.set = res.data.map((singleItem) => ({
        ...singleItem,
        hasBeenEdited: false,
      }));
    });
    // Reset search field
    this.search = "";
  }

  private colorRow(item): string {
    if (item.hasBeenEdited) {
      return "primary lighten-5";
    } else {
      return "";
    }
  }

  // METHODS --- SAVE VALUE
  private sendRowValue(item): void {
    // ready item to send
    let itemToSend = {
      CatalogSourceID: this.selectedCatalog,
      Diameter: item.diameter,
      PrivateQtyToAdd: parseFloat(item.privateQtyToAdd)
        ? parseFloat(item.privateQtyToAdd)
        : 0,
      PublicQtyToAdd: parseFloat(item.publicQtyToAdd)
        ? parseFloat(item.publicQtyToAdd)
        : 0,
    };
    // API here
    catalogService
      .saveCatalogs(itemToSend)
      .then((res) => {
        if (res.status === 200) {
          this.dialogText = "Dati del catalogo modificati correttamente!";
          this.messageDialogOpen = true;
        } else {
          errorHandling();
        }
      })
      .catch((e) => {
        console.warn(e);
        errorHandling();
      });
    // Reset edit state
    item.hasBeenEdited = false;

    let errorHandling = (): void => {
      this.dialogText = "Non è stato possibile modificare i dati del catalogo!";
      this.messageDialogOpen = true;
    };
  }
}
